// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from '../id.js'
import {Rect} from '../rect.js'
import {CharacterRect} from '../search-index/character-rect.js'

export class ImageRecognizedText {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ImageRecognizedText {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsImageRecognizedText(bb: flatbuffers.ByteBuffer, obj?: ImageRecognizedText): ImageRecognizedText {
    return (obj || new ImageRecognizedText()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsImageRecognizedText(
    bb: flatbuffers.ByteBuffer,
    obj?: ImageRecognizedText
  ): ImageRecognizedText {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ImageRecognizedText()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  blockId(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  text(): string | null
  text(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  text(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  characterRects(index: number, obj?: CharacterRect): CharacterRect | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset
      ? (obj || new CharacterRect()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!)
      : null
  }

  characterRectsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  cropRect(obj?: Rect): Rect | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new Rect()).__init(this.bb_pos + offset, this.bb!) : null
  }

  static startImageRecognizedText(builder: flatbuffers.Builder) {
    builder.startObject(4)
  }

  static addBlockId(builder: flatbuffers.Builder, blockIdOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, blockIdOffset, 0)
  }

  static addText(builder: flatbuffers.Builder, textOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, textOffset, 0)
  }

  static addCharacterRects(builder: flatbuffers.Builder, characterRectsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, characterRectsOffset, 0)
  }

  static startCharacterRectsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 2)
  }

  static addCropRect(builder: flatbuffers.Builder, cropRectOffset: flatbuffers.Offset) {
    builder.addFieldStruct(3, cropRectOffset, 0)
  }

  static endImageRecognizedText(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // block_id
    builder.requiredField(offset, 6) // text
    builder.requiredField(offset, 8) // character_rects
    return offset
  }
}
